import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import "./homefooter.css";
import facebook from "../../assets/products/path14.png";
import youtube from "../../assets/products/youtube-168_svgrepo.com.png";
import linkedin from "../../assets/products/linkedin_svgrepo.com.png";

// ✅ Separate DNB Badge component
function DNBBadge() {
  useEffect(() => {
    const script = document.createElement("script");
    // Replace with the exact script D&B gave you
    script.src = "https://dunsregistered.dnb.com";
    script.async = true;
    document.getElementById("dnb-seal-container")?.appendChild(script);
  }, []);

  return (
    <div
      id="dnb-seal-container"
      style={{ textAlign: "center", marginTop: "20px" }}
    />
  );
}

export default function NewFooter() {
  const navigate = useNavigate();

  return (
<div className="home-footer">
  <div className="divider-footer"></div>

  {/* Top Row: Nav */}
  <div className="footer-top">
    <div className="nav-i">
      <h5 onClick={() => navigate("/")}>Home</h5>
      <h5 onClick={() => navigate("/solutions")}>Solutions</h5>
      <h5 onClick={() => navigate("/product/vivre")}>Products</h5>
      <h5 onClick={() => navigate("/customers")}>Customers</h5>
      <h5 onClick={() => navigate("/resources")}>Resources</h5>
      <h5 onClick={() => navigate("/about")}>About Us</h5>
    </div>
  </div>

  <div className="divider-footer"></div>

  {/* Bottom Row */}
  <div className="footer-bottom">
    <div className="terms-conditions">
      <p onClick={() => window.open("/terms&conditions", "_blank")}>
        Terms & conditions
      </p>
      <span className="seperator">{" | "}</span>
      <p onClick={() => window.open("/PrivacyPolicy", "_blank")}>
        Privacy Policy
      </p>
    </div>

    <div className="contacts">
      <a
        className="elementor-button elementor-button-link elementor-size-sm"
        href="mailto:ottsales@horizonind.org?subject=Book%20A%20Demo"
      >
        <div className="email">
          <img
            src={require("../../assets/products/email-9_svgrepo.com.png")}
            style={{ width: "30px", height: "30px", marginRight: "10px" }}
            alt="email"
          />
          <p>contact@horizonind.org</p>
        </div>
      </a>
      <div className="email1">
        <img
          src={require("../../assets/products/call_svgrepo.com.png")}
          style={{ width: "30px", height: "30px", marginRight: "10px" }}
          alt="call"
        />
        <div className="numbers">
          <p>0124 412 9050</p>
        </div>
      </div>
      <div className="location">
        <img
          src={require("../../assets/products/pin-location_svgrepo.com.png")}
          style={{ width: "30px", height: "30px" }}
          alt="location"
        />
        <div className="numbers2">
          <p>17th Cross Rd, Sector 7,
          HSR Layout, Bengaluru,
          Karnataka 560102</p>
        </div>
      </div>
    </div>

    {/* ✅ Socials + DNB Seal */}
    <div className="footer-right">
      <div className="social-icons1">
        <img src={facebook} alt="facebook" className="socialicon" />
        <img
          src={youtube}
          alt="youtube"
          className="socialicon"
          onClick={() =>
            window.open("https://www.youtube.com/@horizonbroadbandpvtltd", "_blank")
          }
        />
        <img
          src={linkedin}
          alt="linkedin"
          className="socialicon"
          onClick={() =>
            window.open("https://www.linkedin.com/company/horizon-broadband-pvt-ltd/", "_blank")
          }
        />
      </div>

      <div className="dnb-seal">
        <DNBBadge />
      </div>
    </div>
  </div>
</div>

  );
}
